import { MAP_LICENSE_TYPE_TO_ICON } from '@yme/components/Header/MenuUnitCard/constants';
import { getImageUrlByDimension } from '@yme/utils/common';
import { MOBILE_KEY } from '@yme/utils/constants';
export function getDriverLicenseIcon(opt) {
    if (opt) {
        return MAP_LICENSE_TYPE_TO_ICON[opt];
    }
    return undefined;
}
export function buildImageProps(image) {
    return {
        ...image,
        src: getImageUrlByDimension({
            src: image?.url || '',
            dimension: MOBILE_KEY,
        }),
        fallbackSrc: image?.url || '',
    };
}
